var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 7 5"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 5L7 0H0z",
  fill: "#EF5A5E",
  fillRule: "evenodd"
})));

export default SvgIconTriangle;